import { breadcrumbSlot } from "@redotech/redo-web/breadcrumb";

/** The policy name as the editor page's last breadcrumb. */
export const policyEditorBreadcrumb = breadcrumbSlot();
